
export const MAX_DAYS_LOGGED_IN = 14;

export const PRICING_PAGE = "https://mycableengineering.com/Pricing";
export const USER_PHOTO_DEFAULT_URL = "https://firebasestorage.googleapis.com/v0/b/mce-app-lotppu.appspot.com/o/images%2FdefaultProfileImage.png?alt=media&token=bab49058-beb7-43cb-bb30-365e444c35232";
export const MYCABLEENGINEERING_LOGO = "https://firebasestorage.googleapis.com/v0/b/mce-app-lotppu.appspot.com/o/images%2FmyCableEngineeringLogo_300x75.png?alt=media&token=0fd7adfe-f716-49f5-8b3e-117fc84bd006";


// General constants for the application -------------------------------------
export const HARD_SPACE = '\u00A0';


export const BS7671_STANDARD_GUID = 'da9e24e4-e402-4290-ace6-31b9f13c7965';
export const ERA6930P3_STANDARD_GUID = 'f24e591e-d04e-446f-94d5-241a8dd4dd25';
export const ERA6930P5_STANDARD_GUID = '81419475-59dc-4743-ade8-7e637919735f';
export const IEC60502P2_STANDARD_GUID = 'ecb87221-609d-4fad-add0-965aeba5881a';
export const UDR_STANDARD_GUID = '927fa71d-e4fd-4393-b3ba-328fc084b9be';
